import React from 'react';
import { PermissionGroup, Permission } from '../types';
import PermissionGroupCard from './PermissionGroupCard';
import styles from '../../../../styles/PermissionManagement.module.css';

interface PermissionGroupListProps {
  groups: PermissionGroup[];
  allPermissions: Permission[];
  onEdit: (group: PermissionGroup) => void;
  onDelete: (groupId: string, groupName: string) => void;
  onToggleStatus: (groupId: string, currentStatus: boolean) => void;
  onTogglePermission: (groupId: string, permissionId: string, isCurrentlyActive: boolean) => void;
}

const PermissionGroupList: React.FC<PermissionGroupListProps> = ({
  groups,
  allPermissions,
  onEdit,
  onDelete,
  onToggleStatus,
  onTogglePermission
}) => {
  if (groups.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyStateIcon}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <h3 className={styles.emptyStateTitle}>No Permission Groups Found</h3>
        <p className={styles.emptyStateDescription}>
          Get started by creating your first permission group. Define custom access levels and manage user permissions efficiently.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.permissionGroupList}>
      {groups.map((group) => (
        <PermissionGroupCard
          key={group.id}
          group={group}
          allPermissions={allPermissions}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleStatus={onToggleStatus}
          onTogglePermission={onTogglePermission}
        />
      ))}
    </div>
  );
};

export default PermissionGroupList;

